import Partner1 from "../dao/Partner1";

const TechStack = () => {
  return (
    <>
      {/* <!-- Partners --> */}
      <section className="overflow-hidden dark:bg-jacarta-900">
        <div className="container">
          <div className="mx-auto mb-4 max-w-xl text-center">
            <h2 className="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl text-center uppercase">
              Technologies
            </h2>
            {/* <p className="text-lg dark:text-jacarta-300">
              Impact DOTs can be used to represent items such as photos, videos, audio,
              and other types of digital files.
            </p> */}
          </div>
        </div>
        <div className="mb-8 flex animate-marqueeRight space-x-8">
          <Partner1 />
        </div>
        {/* End .animate-marqueeRight */}

        {/* <div className="flex animate-marquee space-x-8">
          <Partner2 />
        </div> */}
        {/* animate-marquee */}
      </section>
      {/* <!-- end partners -->  */}
    </>
  );
};

export default TechStack;
